const $html = $('html');
var AR = {
	//Язык страницы (en, ru)
	lang: templateVars.lang,
	//Поддерживаемые фичи
	features: {
		svg: $html.hasClass('feature-svg')
	}
};

/**
 * Локализованый текст
 * @param  {Object} textObj Текст на нескольких языках в формате {ru: 'русский', en: 'english'}
 * @return {String} Строка на текущем языке
 */
AR.locale = function (textObj) {
	return textObj[AR.lang];
};

global.AR = AR;

module.exports = AR;

require('./imageLoad.js');
require('./blurOnLeave.js');
require('./links.js');
require('./viewport.js');
require('./ieAttachmentFixed.js');
require('./triggerResizeOnImageLoad.js');



// WEBPACK FOOTER //
// ./temp/components/core/index.js